import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick'; // Import the Slider component

// Import your expertise images
import expertise1 from '../Images/Engineering.jpg';
import expertise2 from '../Images/IndustrialDesign.jpg';
import expertise3 from '../Images/Interiors.jpg';
import expertise5 from '../Images/UrbanLandscape.jpg';
import expertise6 from '../Images/WorkplaceConsultancy.jpg';
import climateDesign from '../Images/climateAndSustainableDesign.jpg'

const ExpertiseSection = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div className="w-full px-4 md:px-14 text-white mb-14">
            <Link to='/expertise'>
                <h1 className="text-3xl md:text-4xl font-bold mb-8">Expertise</h1>
            </Link>
            <div className="block md:hidden px-4">
                <Slider {...settings}>
                    {[
                        { linkSrc: 'expertise/engineering', src: expertise1, alt: "Engineering", title: "Engineering" },
                        { linkSrc: 'expertise/industrial-design', src: expertise2, alt: "Industrial Design", title: "Industrial Design" },
                        { linkSrc: 'expertise/interiors', src: expertise3, alt: "Interiors", title: "Interiors" },
                        { linkSrc: 'expertise/urban-and-landscape-design', src: expertise5, alt: "Urban and Landscape Design", title: "Urban and Landscape Design" },
                        { linkSrc: 'expertise/workplace-consultancy', src: expertise6, alt: "Workplace Consultancy", title: "Workplace Consultancy" },
                        { linkSrc: 'expertise/climate-and-sustainable-design', src: climateDesign, alt: "Workplace Consultancy", title: "Climate and Sustainable Design" }
                    ].map((item, index) => (
                        <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out" key={index}>
                            <Link to={`/${item.linkSrc}`}>
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    className="w-full h-72 object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                                />
                                <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black to-slate-500/10">
                                    <p className="text-white text-lg font-semibold">{item.title}</p>
                                </div>
                            </Link>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Grid for larger devices */}
            <div className="hidden md:block">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    {[
                        { linkSrc: 'expertise/engineering', src: expertise1, alt: "Engineering", title: "Engineering" },
                        { linkSrc: 'expertise/industrial-design', src: expertise2, alt: "Industrial Design", title: "Industrial Design" },
                        { linkSrc: 'expertise/interiors', src: expertise3, alt: "Interiors", title: "Interiors" },
                        { linkSrc: 'expertise/urban-and-landscape-design', src: expertise5, alt: "Urban and Landscape Design", title: "Urban and Landscape Design" },
                        { linkSrc: 'expertise/workplace-consultancy', src: expertise6, alt: "Workplace Consultancy", title: "Workplace Consultancy" },
                        { linkSrc: 'expertise/climate-and-sustainable-design', src: climateDesign, alt: "Workplace Consultancy", title: "Climate and Sustainable Design" }
                    ].map((item, index) => (
                        <div className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-in-out" key={index}>
                            <Link to={`/${item.linkSrc}`}>
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    className="w-full h-full object-cover transition-transform duration-700 ease-in-out hover:scale-105"
                                />
                                <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black to-slate-500/10">
                                    <p className="text-white text-lg font-semibold">{item.title}</p>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ExpertiseSection;